import { create, type AxiosInstance } from "axios";
import { createContext } from "react";

export const AxiosContext = createContext<AxiosInstance>(create());
